import { Navigate } from "react-router-dom";
import { getUserDetailsInLocalStorage } from "./UserDetails";

const SuperAdminProtectedRoute = ({ children }) => {
  const user = getUserDetailsInLocalStorage();
  
  // FIX: Add null check before accessing user properties
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // FIX: Safe destructuring with default values
  const { role } = user;
  
  // FIX: Check if role exists and is superadmin
  if (role === "superadmin") {
    return children;
  }

  return <Navigate to="/no-access" replace />;
};

export default SuperAdminProtectedRoute;